<div
  #canvasContainer
  class="canvas-container"
  (mousedown)="handleCanvasClick($event)"
  (dblclick)="handleCanvasDblClick($event)"
  (mousemove)="handleCanvasMouseMove($event)"
></div>
